export function NotificationWarningIconSvg() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_9898_5617)">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.64937 7.03672C7.98406 3.01224 9.1514 1 11 1C12.8486 1 14.0159 3.01224 16.3506 7.03671L16.6416 7.53821C18.5817 10.8825 19.5517 12.5547 18.675 13.7773C17.7983 15 15.6292 15 11.2909 15H10.7091C6.37085 15 4.20174 15 3.32501 13.7773C2.44827 12.5547 3.41833 10.8825 5.35844 7.53821L5.64937 7.03672ZM11 4.30556C11.3314 4.30556 11.6 4.56672 11.6 4.88889V8.77778C11.6 9.09994 11.3314 9.36111 11 9.36111C10.6686 9.36111 10.4 9.09994 10.4 8.77778V4.88889C10.4 4.56672 10.6686 4.30556 11 4.30556ZM11 11.8889C11.4418 11.8889 11.8 11.5407 11.8 11.1111C11.8 10.6816 11.4418 10.3333 11 10.3333C10.5582 10.3333 10.2 10.6816 10.2 11.1111C10.2 11.5407 10.5582 11.8889 11 11.8889Z" fill="var(--s-warning)" />
      </g>
      <defs>
        <filter id="filter0_di_9898_5617" x="0" y="0" width="22" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_9898_5617" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9898_5617" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9898_5617" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9898_5617" />
        </filter>
      </defs>
    </svg>
  );
}
